export const AUTH_URLS = {
  LOGIN: '/admin-user/login',
  LOGOUT: '/admin-user/logout',
  LOGIN_WITH_MICROSOFT: 'admin-user/admin-microsoft-login'
};
